export function Pill({ children }: { children: React.ReactNode }) {
	return (
		<span className="inline-block rounded-sm bg-[var(--brand-primary)] px-2 py-1 text-[10px] font-semibold tracking-wide text-white">
			{children}
		</span>
	)
}
